import React from "react";
import PropTypes from "prop-types";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";

export const LiveFeedbackQuestionText = ({ question }) => {
  return (
    <Text size="micro" as="p" textAlign="center">
      {question}
    </Text>
  );
};

LiveFeedbackQuestionText.propTypes = {
  question: PropTypes.string.isRequired,
};

export default LiveFeedbackQuestionText;
